import SpatialReference from '@arcgis/core/geometry/SpatialReference';

// Q: What coordinate system do we use?
// A: The spatial reference for "degrees" is WGS84, and its specific ID is 4326.
// 4326 is the standard WGS84 (Lat/Long), and must be used to support GeoJSON format
export const WGS84_SPATIAL_REFERENCE = { wkid: 4326 };
export const SpatialReferenceWgs84 = new SpatialReference(
  WGS84_SPATIAL_REFERENCE
);
